import React, { useState, useEffect, useRef } from 'react';
import FeatherIcon from 'feather-icons-react';
// import PropTypes from 'prop-types';
// import moment from 'moment'
import parse from 'html-react-parser';
import { useSelector, useDispatch } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import { Drawer, Empty, message, Skeleton } from 'antd';
import { setChatCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import ConfirmationPopup from '../../Popup/ConfirmationPopup'
import { Footer } from '../../style'
import { CancelIcon, ClearChatIcon } from '../../../../components/Icons/Icons';
import { Button } from '../../../../components/buttons/buttons';
import { getSocket } from "../../../../Api/Socket";
import { fetchLastchatHistory, Userchatsubmit, genieChatDelte, genieChatClear } from "../../../../Api/Services/ChatbotapiService"

function Filters() {
    const scrollRef = useRef(null);
    const dispatch = useDispatch()
    const localData = useSelector((state) => state.localRedux);
    const chatBot = useSelector((state) => state.chatRedux.chatBot);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const [inputValue, setInputValue] = useState()
    const [chatList, setChatList] = useState()
    const [confirmPopup, setConfirmPopup] = useState(false)
    const [confirmPopup1, setConfirmPopup1] = useState(false)
    const [deleteId, setDeleteId] = useState()
    const [display, setDisplay] = useState(false)
    const FilterOpen1 = () => {
        dispatch(setChatCall(false));
        setChatList()
        setInputValue("")
        setDisplay(false)
    }
    async function AllChatHistory() {
        try {
            const response = await fetchLastchatHistory(companyProfile.companyCode)
            const SortedData = response.sort((a, b) => a.chatHistoryId - b.chatHistoryId);
            setChatList(SortedData)
        }
        catch (error) {
            message.error(error)
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            AllChatHistory(),
        ])
    };
    useEffect(() => {
        if (chatBot) {
            fetchAll();
            setDisplay(false)
        }
    }, [chatBot])
    const handleChange = e => {
        setInputValue(e.target.value)
    };
    const handleSubmit = async () => {
        setDisplay(true)
        setInputValue("")
        setChatList([...chatList, { chatHistoryId: "Temp_1", query: inputValue, response: "LoadingFromAi" }])
        const payload =
        {
            companyCode: companyProfile.companyCode,
            queryText: inputValue,
            limit: 20
        }
        try {
            const response = await Userchatsubmit(payload)
            if (response.status === 201) {
                setDisplay(false)
                setInputValue("")
            }
        }
        catch (error) {
            setDisplay(false)
            setInputValue("")
            message.error(error)
        }
    }
    useEffect(() => {
        const socket = getSocket();
        const handleNotification = (data) => {
            setChatList(prev => {
                const list = Array.isArray(prev) ? prev : [];
                const originalData = list.filter(
                    item => item?.chatHistoryId !== "Temp_1"
                );
                return [...originalData, data];
            });
        }
        socket.off("chat_update", handleNotification);
        socket.on("chat_update", handleNotification);
        const handleConnect = () => {
            socket.emit("join", profile.userId);
        };
        socket.off("connect", handleConnect);
        socket.on("connect", handleConnect);
        return () => {
            socket.off("chat_update", handleNotification);
            socket.off("connect", handleConnect);
        };
    }, [profile.userId]);
    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollToBottom();
        }
    }, [chatList]);
    const OnClickofDelete = (value) => {
        setConfirmPopup(true)
        setDeleteId(value)
    }
    const OnClickofDelete1 = () => {
        setConfirmPopup1(true)
    }
    async function deleteMenu(id) {
        let hideMessage; try {
            hideMessage = message.loading("Loading...", 0);
            const Response = await genieChatDelte(id)
            if (Response.status === 200) {
                setConfirmPopup(false)
                AllChatHistory()
                hideMessage();
                setDisplay(false)
            }
        } catch (error) {
            setDisplay(false)
            if (hideMessage) hideMessage();
            message.error(error)
        }
    }
    async function deleteMenu2() {
        let hideMessage; try {
            hideMessage = message.loading("Loading...", 0);
            const Response = await genieChatClear(companyProfile.companyCode)
            if (Response.status === 200) {
                setConfirmPopup1(false)
                AllChatHistory()
                hideMessage();
                setDisplay(false)
            }
        } catch (error) {
            setDisplay(false)
            if (hideMessage) hideMessage();
            message.error(error)
        }
    }
    return (
        <>
            <Drawer
                className="Drawer-Header chat-Drawer"
                bodyStyle={{ padding: 0, display: "flex", flexDirection: "column", height: "100%" }}
                title={<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", padding: "0px 9px 0px 10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <img
                            src={require('../../../../static/img/defaultImages/GenieIcon.png')} alt="Genie" className="genie-icon"
                            style={{ width: 40, height: 40, borderRadius: "50%", background: "white", padding: 3 }}
                        />
                        <div>
                            <div style={{ fontSize: 18, fontWeight: 500, color: "white" }}>Genie</div>
                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                <span className="botActive-dot" />
                                <span style={{ fontSize: 12, color: "#adb4d2" }}>Active now</span>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}
                    >
                        {/* ✅ Clear Chat Button */}
                        {chatList?.length > 0 ? <div
                            className="Hover-Refresh2 back-hover1 able-style"
                            style={{ color: "white" }}
                            role="button"
                            tabIndex={0}
                            title="Clear Chat"
                            onClick={() => {
                                if (!display) { OnClickofDelete1() }
                            }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter" || event.key === " ") {
                                    if (!display) { OnClickofDelete1() }
                                }
                            }}
                        >
                            <ClearChatIcon width={24} height={24} marginRight={5} />
                        </div> : <></>}
                        {/* ❌ Close Button */}
                        <div
                            className="Hover-Refresh2 back-hover1 able-style"
                            style={{ color: "white" }}
                            role="button"
                            tabIndex={0}
                            title="Close Chat"
                            onClick={() => { if (!display) { FilterOpen1() } }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter" || event.key === " ") {
                                    if (!display) { FilterOpen1(); }
                                }
                            }}
                        >
                            <CancelIcon width={30} height={30} />
                        </div>
                    </div>
                </div>}
                closable={false}
                placement="right"
                open={chatBot}
                width="50%"
                footer={[
                    <Footer>
                        <div className="chatbox-reply-form d-flex">
                            <div className="chatbox-reply-input">
                                <input
                                    onChange={handleChange}
                                    placeholder="Type your message..."
                                    name="chat"
                                    id="chat"
                                    style={{ width: '100%' }}
                                    value={inputValue}
                                    disabled={display}
                                />
                            </div>
                            <div className="chatbox-reply-action d-flex">
                                <Button onClick={handleSubmit} className="gradient-button" disabled={display || !inputValue || inputValue.trim() === ""}>
                                    <FeatherIcon icon="send" size={20} />
                                </Button>
                            </div>
                        </div>
                    </Footer>
                ]}
            >
                <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200} ref={scrollRef}>
                    <div style={{ padding: "20px 30px" }}>
                        {(chatList === null || chatList === undefined) ? (
                            <Skeleton
                                paragraph={{ rows: 20, width: "100%" }}
                                active
                                title={false}
                            />) :
                            chatList.length === 0 ? (
                                <Empty
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                    description={
                                        <span style={{ color: "#999", fontSize: 14 }}>
                                            No chat available
                                        </span>
                                    }
                                    style={{ marginTop: "30px" }}
                                />) : (
                                chatList.map((item, index) => (
                                    <div key={index}>
                                        {item.query && (
                                            <div className="chatBot-message chatBot-right">
                                                <div className="chatbot-row">
                                                    <div className="bubble userchatBot-bubble user-bubble-wrapper">
                                                        {item.query}
                                                        {typeof item.chatHistoryId === "number" && (
                                                            <span
                                                                role="button"
                                                                tabIndex={0}
                                                                aria-label="Delete chat"
                                                                className="chat-delete-icon fetcherDelete-Icon"
                                                                onClick={() => OnClickofDelete(item.chatHistoryId)}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                                        OnClickofDelete(item.chatHistoryId);
                                                                    }
                                                                }} >
                                                                <FeatherIcon icon="trash-2" size={14} />
                                                            </span>
                                                        )}
                                                    </div>
                                                    {(profile?.profilePic && profile.profilePic !== "") ?
                                                        <img
                                                            src={profile?.profilePic}
                                                            alt="User"
                                                            className="chatbot-avatar"
                                                        /> :
                                                        <span className='details_span_Tag UserIcon chatbot-avatar' style={{ flexShrink: 0, }}>
                                                            {profile?.firstName.slice(0, 1).toUpperCase()}
                                                        </span>
                                                    }
                                                </div>
                                            </div>
                                        )}
                                        {item.response === "LoadingFromAi" ? (
                                            <div className="bubble bot-bubble loadingBot-bubble">
                                                <span className="dotBot" />
                                                <span className="dotBot" />
                                                <span className="dotBot" />
                                                <span className="dotBot" />
                                                <span className="dotBot" />
                                            </div>
                                        ) : (
                                            <div className="chatBot-message chatBot-left">
                                                <div className="chatbot-row">
                                                    <img
                                                        src={require('../../../../static/img/defaultImages/GenieIcon.png')} alt="Genie" className="chatbot-avatar1"
                                                    />
                                                    <div className="bubble chatbot-bubble">
                                                        {parse(item.response)}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))
                            )}
                    </div>
                </Scrollbars>
            </Drawer >
            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={deleteMenu} deleteId={deleteId} page="Delete" />}
            {confirmPopup1 && <ConfirmationPopup confirmPopup={confirmPopup1} setConfirmPopup={setConfirmPopup1} GetCallback={deleteMenu2} page="Clear" />}

        </>
    );
}

Filters.propTypes = {
};

export default Filters;
